// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-video[data-v-8ba10d9e]{-o-object-fit:cover;object-fit:cover;height:100%;width:96%}@media(min-width:992px)and (max-width:99999px){.base-video[data-v-8ba10d9e]{height:800px;width:400px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
